// Import globalnych stylów i skryptów
require('./assets/scss/_all.scss'); // Style globalne dla frontu
require('./assets/js/app'); // Skrypty globalne dla frontu

// Dynamiczne importowanie plików z bloków
const blocksContext = require.context(
    './template/blocks', // Ścieżka do katalogu bloków
    true,                // Przeszukuj podkatalogi
    /(scripts\.js|style\.scss)$/ // Dopasuj pliki scripts.js i style.scss
);

// Importuj każdy znaleziony plik
blocksContext.keys().forEach(blocksContext);
